module.exports = __webpack_public_path__ + "img/registerreturn-icon-green.b3f8051b.svg";